import axios from "axios";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const { clientId } = useParams(); // optional if route contains it

  const handleRetry = async() => {
    // Redirect to backend endpoint that re-initializes payment
   await axios.post( process.env.REACT_APP_BACKEND_URL+`/api/paystack/retry`, {clientId})
    .then((res)=> {
        window.location.href = res.data.newUrl
    })
    .catch((err)=> {
        console.log(err)
    })
  };



  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Payment Failed</h1>

        <p style={styles.text}>
          We couldn't complete your subscription payment.
          <br />
          Please try again to activate your unlimited consultations.
        </p>

        <div style={styles.buttonGroup}>
          <button style={styles.retryBtn} onClick={handleRetry}>
            Try Again
          </button>

          
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f8f9fa",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    textAlign: "center",
    maxWidth: "450px",
  },
  title: {
    color: "#d9534f",
    marginBottom: "20px",
  },
  text: {
    marginBottom: "30px",
    fontSize: "16px",
    color: "#555",
  },
  buttonGroup: {
    display: "flex",
    gap: "15px",
    justifyContent: "center",
  },
  retryBtn: {
    padding: "12px 20px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  backBtn: {
    padding: "12px 20px",
    backgroundColor: "#6c757d",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

export default PaymentFailed;